<sdps-modal-beta sdps-title="Confirm change to tax withholding elections" id="{{modalId}}">
    <div slot="modal-body">
        <mm-spinner [loading]="editTweModalState$"></mm-spinner>
        <a id="print-link" (click)="onPrintClicked()"><i id="print-icon" class="sch-print"></i> Print</a>
        <div>
            <div class="sdps-text-body"><span>{{paragraphOne}}</span></div><br>
            <div class="sdps-text-body"><span>{{paragraphTwo}}</span></div>
            <mm-twe-modal-tables [upcomingTransactions$]="upcomingTransactions$" [sloas$]="sloas$"
                [recurringTransactions$]="recurringTransactions$"
                [tweTableState$]="tweTableState$"></mm-twe-modal-tables>
        </div>
    </div>
    <div slot="modal-footer">
        <button (click)="onCancelClick()" type="button" id="lc_cancel_twe_change"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
        <button (click)="onConfirmClick()" type="button" id="lc_confirm_twe_change"
            class="sdps-button sdps-button--primary sdps-button--small">Confirm</button>
    </div>
</sdps-modal-beta>